import React from "react";
import "../styles/howWeWork.css";

import consultImg from "../assets/image.jpg";
import docImg from "../assets/download.jpg";
import govtImg from "../assets/governament.jpg";
import followImg from "../assets/consultation.jpg";
import supportImg from "../assets/home/main8.jpeg";

const timelineData = [
  {
    side: "left",
    title: "Initial Consultation",
   image: consultImg,
    points: [
      "Our process begins with a detailed consultation to understand the client’s business operations, project requirements, and eligibility for various government schemes and regulatory approvals. During this stage, we analyze the client’s objectives and provide guidance on the most suitable DGFT licenses, industrial subsidy programs, and compliance requirements applicable to their business.",
    ],
  },
  {
    side: "right",
    title: "Documentation & Application Preparation",
   image: docImg,
    points: [
      "Once the requirements are identified, our team assists in collecting and reviewing all necessary documentation. We ensure that every document is properly verified and prepared according to the prescribed government guidelines. Our experts then prepare and structure the application forms and supporting documents to ensure accuracy and compliance.",
    ],
  },
  {
    side: "left",
    title: "Government Liaison & Submission",
    image: govtImg,
    points: [
      "After the documentation is finalized, we proceed with the submission of applications to the concerned government departments. Our team actively coordinates with relevant authorities to ensure smooth processing, proper communication, and adherence to regulatory procedures throughout the submission stage.",
    ],
  },
   {
    side: "right",
    title: "Follow-Up & Approval",
    image: followImg,
    points: [
      "We continuously monitor the progress of the submitted applications and maintain regular follow-ups with the concerned departments. Any queries or clarifications raised by authorities are addressed promptly to ensure that the approval process moves forward efficiently and without unnecessary delays.",
    ],
  },
    {
    side: "left",
    title: "Final Compliance & Ongoing Support",
    image: supportImg,
    points: [
"Once approvals are obtained, we assist clients in completing any remaining compliance formalities and reporting requirements. Our support does not end with approval; we continue to provide guidance on regulatory obligations, ensuring that businesses remain compliant and can operate smoothly without future complications.",
      ],
  },
];

export default function HowWeWork() {
  return (
    <section className="howwork-section">
      <div className="container">

        {/* TOP CONTENT */}
        {/* <p className="small-title"> APEX Consultant</p> */}

        <h2 className="main-title">How We Work</h2>

        <div className="green-line"></div>

        <div className="top-content">
          {/* <p>
           At APEX Consultants, we follow a structured and transparent approach to ensure smooth processing of every project. Our goal is to simplify complex regulatory procedures related to DGFT liaisoning, industrial subsidies, and government compliance while keeping our clients informed at every stage.</p>
          <p>We believe that clear communication, accurate documentation, and systematic workflow are essential for successful approvals and timely completion of regulatory processes. Our experienced team works closely with clients to understand their requirements and provide practical solutions tailored to their business needs.</p>
          <p>Our step-by-step process helps industries obtain licenses, approvals, and government incentives efficiently while minimizing delays and compliance risks.
          </p> */}

          <p>At APEX Consultancy process we follow a simple and transparent to support our clients, first we understand client's requirements and provide expert guidance on the suitable services our team then assists with documentation, application preparation, and submission related to DGFT, Export & Import, NABARD and other Central Government subsidies we continuously coordinate and follow up with the concerned departments to ensure a smooth and efficient save time and focus on growth.</p>
          <p>Our goal is to make government procedures simple, Transparent and hassle free for our clients.</p>

          </div>

        {/* TIMELINE */}
        <div className="timeline-wrapper">

          <div className="timeline-line"></div>

       {timelineData.map((item, index) => (
  <div
    key={index}
    className={`timeline-row ${
      item.side === "right" ? "right" : "left"
    }`}
  >
    <div className="timeline-content">
      <h3>{item.title}</h3>
      <ol>
        {item.points.map((p, i) => (
          <li key={i}>{p}</li>
        ))}
      </ol>
    </div>

    <div className="timeline-node">
<div className="circle">
  <img src={item.image} alt={item.title} />
             </div>
           </div>
  </div>
))}

        </div>

      </div>
    </section>
  );
}